{
	"Title": "MTG Deck",
	"Head_MyDeck": "MyDeck",
	"Head_DeckBuilder": "DeckBuilder",
	"Head_SearchSetting": "SearchSetting",
	"Head_CardSearch": "CardSearch",
	"Head_Option": "Option",
	"MyDeck_AddDeck": "Add Deck",
	"MyDeck_DeckName": "Name",
	"MyDeck_InputDeckName": "Input name",
	"Option_About": "About",
	"Option_UpdateHistory": "Update History",
	"Option_PrivacyPolicy": "Privacy Policy",
	"Option_SupportForm": "Support Form",
	"Common_Yes": "Yes",
	"Common_No": "No",
	"Common_OK": "OK",
	"Common_NG": "Cancel",
	"Common_Previous": "Previous",
	"Common_Next": "Next",
	"Common_Attention": "Attention",
	"Common_Warning": "Warning",
	"Common_Upload": "Upload",
	"Common_Download": "Download",
	"Common_Save": "Save",
	"Common_Load": "Load",
	"Common_Open": "Open",
	"Common_Close": "Close",
	"Common_Delete": "Delete",
	"Common_Trash": "🗑️",
	"Common_Information": "Information",
	"Common_Total": "Total",
	"Common_Include": "Include",
	"Common_Exclude": "Exclude",
	"Common_Other": "Other",
	"Common_Login": "Login",
	"Common_LoginNow": "Login Now",
	"Common_Logout": "Logout",
	"Common_Account": "Account",
	"Common_DeleteAccount": "Delete Account",
	"Common_DeleteSave": "Delete Save",
	"Common_Copy": "Copy",
	"Common_Paste": "Paste",
	"MTGA_Import": "MTGA Import",
	"MTGA_Export": "MTGA Export",
	"DeleteAccountAsk": "Delete Account?",
	"DeleteSaveAsk": "Delete Save?",
	"LoginGoogle": "Login with Google",
	"AddCard": "Add Card",
	"ClearCard": "Clear Card",
	"AddGroup": "Add Group",
	"DeleteGroup": "Delete Group",
	"DeleteGroupAsk": "Delete this group?",
	"SupportForm_Desc": "This is SupportForm.",
	"SupportForm_Email": "Name",
	"SupportForm_Message": "Message",
	"SupportForm_Attention": "{0} characters or less.",
	"Card_Language": "Language",
	"Card_Set": "Card Set",
	"Card_Name": "Card Name",
	"Card_ArtifactType": "Artifact Type",
	"Card_EnchantmentType": "Enchantment Type",
	"Card_LandType": "Land Type",
	"Card_SpellType": "Spell Type",
	"Card_CreatureType": "Creature Type",
	"Card_BattleType": "Battle Type",
	"Card_FrameEffect": "Frame Effect",
	"Card_KeywordAbility": "Keyword Ability",
	"Card_ColorIdentity": "Color Identity",
	"CardType_Creature": "Creature",
	"CardType_Artifact": "Artifact",
	"CardType_Enchantment": "Enchantment",
	"CardType_Land": "Land",
	"CardType_Instant": "Instant",
	"CardType_Sorcery": "Sorcery",
	"CardType_Planeswalker": "Planeswalker",
	"Supertype_null": "Supertype None",
	"Supertype_legendary": "Legendary",
	"Supertype_world": "World",
	"Supertype_basic": "Basic",
	"Rarity_common": "Common",
	"Rarity_uncommon": "Uncommon",
	"Rarity_rare": "Rare",
	"Rarity_mythic": "Mythic",
	"CardAvailability_paper": "Paper",
	"CardAvailability_arena": "Arena",
	"CardAvailability_mtgo": "MTGO",
	"About_References": "References",
	"About_Message": "This site is unofficial fan content for Magic: The Gathering.\n\nI created this deck-building tool as both a hobby project and a way to learn and practice development.\n\nAs my paper card collection kept growing and became harder to manage, I also wished there were a Commander version of MTGA, which inspired me to build this site.\n\nI hope it can also be useful for managing card collections and wishlists. Browsing cards is fun too.\n\nUpdates are irregular, but I would appreciate your warm support and understanding. Feedback and suggestions are always welcome.",
	"Right_MTG_Description": "It is a fascinating trading card game.",
	"Right_MTGJSON_Description": "Card data provided by MTGJSON.",
	"Right_Scryfall_Description": "Card images provided by Scryfall.",
	"Right_Bootstrap_Description": "Bootstrap is used for the site's design.",
	"Right_Pragmatic_Description": "Atlassian's Trello library is used to create an MTGA-style deck-building page.",
	"Keyword_Absorb": "Absorb",
	"Keyword_Affinity": "Affinity",
	"Keyword_Afflict": "Afflict",
	"Keyword_Afterlife": "Afterlife",
	"Keyword_Aftermath": "Aftermath",
	"Keyword_Amplify": "Amplify",
	"Keyword_Annihilator": "Annihilator",
	"Keyword_Ascend": "Ascend",
	"Keyword_Assist": "Assist",
	"Keyword_Augment": "Augment",
	"Keyword_Aura Swap": "Aura Swap",
	"Keyword_Awaken": "Awaken",
	"Keyword_Backup": "Backup",
	"Keyword_Banding": "Banding",
	"Keyword_Bargain": "Bargain",
	"Keyword_Basic landcycling": "Basic landcycling",
	"Keyword_Battle Cry": "Battle Cry",
	"Keyword_Bestow": "Bestow",
	"Keyword_Blitz": "Blitz",
	"Keyword_Bloodthirst": "Bloodthirst",
	"Keyword_Boast": "Boast",
	"Keyword_Bushido": "Bushido",
	"Keyword_Buyback": "Buyback",
	"Keyword_Cascade": "Cascade",
	"Keyword_Casualty": "Casualty",
	"Keyword_Champion": "Champion",
	"Keyword_Changeling": "Changeling",
	"Keyword_Choose a background": "Choose a background",
	"Keyword_Cipher": "Cipher",
	"Keyword_Cleave": "Cleave",
	"Keyword_Commander ninjutsu": "Commander ninjutsu",
	"Keyword_Companion": "Companion",
	"Keyword_Compleated": "Compleated",
	"Keyword_Conspire": "Conspire",
	"Keyword_Convoke": "Convoke",
	"Keyword_Craft": "Craft",
	"Keyword_Crew": "Crew",
	"Keyword_Cumulative upkeep": "Cumulative upkeep",
	"Keyword_Cycling": "Cycling",
	"Keyword_Dash": "Dash",
	"Keyword_Daybound": "Daybound",
	"Keyword_Deathtouch": "Deathtouch",
	"Keyword_Decayed": "Decayed",
	"Keyword_Defender": "Defender",
	"Keyword_Delve": "Delve",
	"Keyword_Demonstrate": "Demonstrate",
	"Keyword_Desertwalk": "Desertwalk",
	"Keyword_Dethrone": "Dethrone",
	"Keyword_Devoid": "Devoid",
	"Keyword_Devour": "Devour",
	"Keyword_Disguise": "Disguise",
	"Keyword_Disturb": "Disturb",
	"Keyword_Doctor's companion": "Doctor's companion",
	"Keyword_Double agenda": "Double agenda",
	"Keyword_Double strike": "Double strike",
	"Keyword_Double team": "Double team",
	"Keyword_Dredge": "Dredge",
	"Keyword_Echo": "Echo",
	"Keyword_Embalm": "Embalm",
	"Keyword_Emerge": "Emerge",
	"Keyword_Enchant": "Enchant",
	"Keyword_Encore": "Encore",
	"Keyword_Enlist": "Enlist",
	"Keyword_Entwine": "Entwine",
	"Keyword_Epic": "Epic",
	"Keyword_Equip": "Equip",
	"Keyword_Escalate": "Escalate",
	"Keyword_Escape": "Escape",
	"Keyword_Eternalize": "Eternalize",
	"Keyword_Evoke": "Evoke",
	"Keyword_Evolve": "Evolve",
	"Keyword_Exalted": "Exalted",
	"Keyword_Exhaust": "Exhaust",
	"Keyword_Exploit": "Exploit",
	"Keyword_Extort": "Extort",
	"Keyword_Fabricate": "Fabricate",
	"Keyword_Fading": "Fading",
	"Keyword_Fear": "Fear",
	"Keyword_Firebending": "Firebending",
	"Keyword_First strike": "First strike",
	"Keyword_Flanking": "Flanking",
	"Keyword_Flash": "Flash",
	"Keyword_Flashback": "Flashback",
	"Keyword_Flying": "Flying",
	"Keyword_For Mirrodin!": "For Mirrodin!",
	"Keyword_Forecast": "Forecast",
	"Keyword_Forestcycling": "Forestcycling",
	"Keyword_Forestwalk": "Forestwalk",
	"Keyword_Foretell": "Foretell",
	"Keyword_Fortify": "Fortify",
	"Keyword_Freerunning": "Freerunning",
	"Keyword_Frenzy": "Frenzy",
	"Keyword_Friends forever": "Friends forever",
	"Keyword_Fuse": "Fuse",
	"Keyword_Gift": "Gift",
	"Keyword_Graft": "Graft",
	"Keyword_Gravestorm": "Gravestorm",
	"Keyword_Harmonize": "Harmonize",
	"Keyword_Haste": "Haste",
	"Keyword_Haunt": "Haunt",
	"Keyword_Hexproof": "Hexproof",
	"Keyword_Hexproof from": "Hexproof from",
	"Keyword_Hidden agenda": "Hidden agenda",
	"Keyword_Hideaway": "Hideaway",
	"Keyword_Horsemanship": "Horsemanship",
	"Keyword_Impending": "Impending",
	"Keyword_Improvise": "Improvise",
	"Keyword_Indestructible": "Indestructible",
	"Keyword_Infect": "Infect",
	"Keyword_Ingest": "Ingest",
	"Keyword_Intensity": "Intensity",
	"Keyword_Intimidate": "Intimidate",
	"Keyword_Islandcycling": "Islandcycling",
	"Keyword_Islandwalk": "Islandwalk",
	"Keyword_Job select": "Job select",
	"Keyword_Jump-start": "Jump-start",
	"Keyword_Kicker": "Kicker",
	"Keyword_Landcycling": "Landcycling",
	"Keyword_Landwalk": "Landwalk",
	"Keyword_Legendary landwalk": "Legendary landwalk",
	"Keyword_Level Up": "Level Up",
	"Keyword_Lifelink": "Lifelink",
	"Keyword_Living metal": "Living metal",
	"Keyword_Living weapon": "Living weapon",
	"Keyword_Madness": "Madness",
	"Keyword_Max speed": "Max speed",
	"Keyword_Mayhem": "Mayhem",
	"Keyword_Megamorph": "Megamorph",
	"Keyword_Melee": "Melee",
	"Keyword_Menace": "Menace",
	"Keyword_Mentor": "Mentor",
	"Keyword_Miracle": "Miracle",
	"Keyword_Mobilize": "Mobilize",
	"Keyword_Modular": "Modular",
	"Keyword_More Than Meets the Eye": "More Than Meets the Eye",
	"Keyword_Morph": "Morph",
	"Keyword_Mountaincycling": "Mountaincycling",
	"Keyword_Mountainwalk": "Mountainwalk",
	"Keyword_Multikicker": "Multikicker",
	"Keyword_Mutate": "Mutate",
	"Keyword_Myriad": "Myriad",
	"Keyword_Nightbound": "Nightbound",
	"Keyword_Ninjutsu": "Ninjutsu",
	"Keyword_Nonbasic landwalk": "Nonbasic landwalk",
	"Keyword_Offering": "Offering",
	"Keyword_Offspring": "Offspring",
	"Keyword_Outlast": "Outlast",
	"Keyword_Overload": "Overload",
	"Keyword_Partner": "Partner",
	"Keyword_Partner with": "Partner with",
	"Keyword_Persist": "Persist",
	"Keyword_Phasing": "Phasing",
	"Keyword_Plainscycling": "Plainscycling",
	"Keyword_Plainswalk": "Plainswalk",
	"Keyword_Poisonous": "Poisonous",
	"Keyword_Protection": "Protection",
	"Keyword_Prototype": "Prototype",
	"Keyword_Provoke": "Provoke",
	"Keyword_Prowess": "Prowess",
	"Keyword_Prowl": "Prowl",
	"Keyword_Rampage": "Rampage",
	"Keyword_Ravenous": "Ravenous",
	"Keyword_Reach": "Reach",
	"Keyword_Read Ahead": "Read Ahead",
	"Keyword_Rebound": "Rebound",
	"Keyword_Reconfigure": "Reconfigure",
	"Keyword_Recover": "Recover",
	"Keyword_Reinforce": "Reinforce",
	"Keyword_Renown": "Renown",
	"Keyword_Replicate": "Replicate",
	"Keyword_Retrace": "Retrace",
	"Keyword_Riot": "Riot",
	"Keyword_Ripple": "Ripple",
	"Keyword_Saddle": "Saddle",
	"Keyword_Scavenge": "Scavenge",
	"Keyword_Shadow": "Shadow",
	"Keyword_Shroud": "Shroud",
	"Keyword_Skulk": "Skulk",
	"Keyword_Slivercycling": "Slivercycling",
	"Keyword_Soulbond": "Soulbond",
	"Keyword_Soulshift": "Soulshift",
	"Keyword_Specialize": "Specialize",
	"Keyword_Spectacle": "Spectacle",
	"Keyword_Splice": "Splice",
	"Keyword_Split second": "Split second",
	"Keyword_Spree": "Spree",
	"Keyword_Squad": "Squad",
	"Keyword_Station": "Station",
	"Keyword_Storm": "Storm",
	"Keyword_Sunburst": "Sunburst",
	"Keyword_Surge": "Surge",
	"Keyword_Suspend": "Suspend",
	"Keyword_Swampcycling": "Swampcycling",
	"Keyword_Swampwalk": "Swampwalk",
	"Keyword_Toxic": "Toxic",
	"Keyword_Training": "Training",
	"Keyword_Trample": "Trample",
	"Keyword_Transfigure": "Transfigure",
	"Keyword_Transmute": "Transmute",
	"Keyword_Tribute": "Tribute",
	"Keyword_Typecycling": "Typecycling",
	"Keyword_Umbra armor": "Umbra armor",
	"Keyword_Undaunted": "Undaunted",
	"Keyword_Undying": "Undying",
	"Keyword_Unearth": "Unearth",
	"Keyword_Unleash": "Unleash",
	"Keyword_Vanishing": "Vanishing",
	"Keyword_Vigilance": "Vigilance",
	"Keyword_Ward": "Ward",
	"Keyword_Warp": "Warp",
	"Keyword_Web-slinging": "Web-slinging",
	"Keyword_Wither": "Wither",
	"Keyword_Wizardcycling": "Wizardcycling",
	"Subtype_Attraction": "Attraction",
	"Subtype_Blood": "Blood",
	"Subtype_Clue": "Clue",
	"Subtype_Contraption": "Contraption",
	"Subtype_Equipment": "Equipment",
	"Subtype_Food": "Food",
	"Subtype_Fortification": "Fortification",
	"Subtype_Gold": "Gold",
	"Subtype_Incubator": "Incubator",
	"Subtype_Map": "Map",
	"Subtype_Powerstone": "Powerstone",
	"Subtype_Treasure": "Treasure",
	"Subtype_Vehicle": "Vehicle",
	"Subtype_Aura": "Aura",
	"Subtype_Background": "Background",
	"Subtype_Cartouche": "Cartouche",
	"Subtype_Class": "Class",
	"Subtype_Curse": "Curse",
	"Subtype_Role": "Role",
	"Subtype_Rune": "Rune",
	"Subtype_Saga": "Saga",
	"Subtype_Shard": "Shard",
	"Subtype_Shrine": "Shrine",
	"Subtype_Desert": "Desert",
	"Subtype_Forest": "Forest",
	"Subtype_Gate": "Gate",
	"Subtype_Island": "Island",
	"Subtype_Lair": "Lair",
	"Subtype_Locus": "Locus",
	"Subtype_Mine": "Mine",
	"Subtype_Mountain": "Mountain",
	"Subtype_Plains": "Plains",
	"Subtype_Power-Plant": "Power-Plant",
	"Subtype_Sphere": "Sphere",
	"Subtype_Swamp": "Swamp",
	"Subtype_Tower": "Tower",
	"Subtype_Urza's": "Urza's",
	"Subtype_Adventure": "Adventure",
	"Subtype_Arcane": "Arcane",
	"Subtype_Lesson": "Lesson",
	"Subtype_Trap": "Trap",
	"Subtype_Advisor": "Advisor",
	"Subtype_Aetherborn": "Aetherborn",
	"Subtype_Alien": "Alien",
	"Subtype_Ally": "Ally",
	"Subtype_Angel": "Angel",
	"Subtype_Antelope": "Antelope",
	"Subtype_Ape": "Ape",
	"Subtype_Archer": "Archer",
	"Subtype_Archon": "Archon",
	"Subtype_Army": "Army",
	"Subtype_Artificer": "Artificer",
	"Subtype_Assassin": "Assassin",
	"Subtype_Assembly-Worker": "Assembly-Worker",
	"Subtype_Astartes": "Astartes",
	"Subtype_Atog": "Atog",
	"Subtype_Aurochs": "Aurochs",
	"Subtype_Avatar": "Avatar",
	"Subtype_Azra": "Azra",
	"Subtype_Badger": "Badger",
	"Subtype_Balloon": "Balloon",
	"Subtype_Barbarian": "Barbarian",
	"Subtype_Bard": "Bard",
	"Subtype_Basilisk": "Basilisk",
	"Subtype_Bat": "Bat",
	"Subtype_Bear": "Bear",
	"Subtype_Beast": "Beast",
	"Subtype_Beeble": "Beeble",
	"Subtype_Beholder": "Beholder",
	"Subtype_Berserker": "Berserker",
	"Subtype_Bird": "Bird",
	"Subtype_Boar": "Boar",
	"Subtype_Bringer": "Bringer",
	"Subtype_Brushwagg": "Brushwagg",
	"Subtype_Camel": "Camel",
	"Subtype_Capybara": "Capybara",
	"Subtype_Carrier": "Carrier",
	"Subtype_Cat": "Cat",
	"Subtype_Centaur": "Centaur",
	"Subtype_Cephalid": "Cephalid",
	"Subtype_Child": "Child",
	"Subtype_Chimera": "Chimera",
	"Subtype_Citizen": "Citizen",
	"Subtype_Cleric": "Cleric",
	"Subtype_Clown": "Clown",
	"Subtype_Cockatrice": "Cockatrice",
	"Subtype_Construct": "Construct",
	"Subtype_Coward": "Coward",
	"Subtype_Crab": "Crab",
	"Subtype_Crocodile": "Crocodile",
	"Subtype_Custodes": "Custodes",
	"Subtype_Cyberman": "Cyberman",
	"Subtype_Cyclops": "Cyclops",
	"Subtype_Dalek": "Dalek",
	"Subtype_Dauthi": "Dauthi",
	"Subtype_Demigod": "Demigod",
	"Subtype_Demon": "Demon",
	"Subtype_Designer": "Designer",
	"Subtype_Detective": "Detective",
	"Subtype_Devil": "Devil",
	"Subtype_Dinosaur": "Dinosaur",
	"Subtype_Djinn": "Djinn",
	"Subtype_Doctor": "Doctor",
	"Subtype_Dog": "Dog",
	"Subtype_Dragon": "Dragon",
	"Subtype_Drake": "Drake",
	"Subtype_Dreadnought": "Dreadnought",
	"Subtype_Drone": "Drone",
	"Subtype_Druid": "Druid",
	"Subtype_Dryad": "Dryad",
	"Subtype_Dwarf": "Dwarf",
	"Subtype_Efreet": "Efreet",
	"Subtype_Egg": "Egg",
	"Subtype_Elder": "Elder",
	"Subtype_Eldrazi": "Eldrazi",
	"Subtype_Elemental": "Elemental",
	"Subtype_Elephant": "Elephant",
	"Subtype_Elf": "Elf",
	"Subtype_Elk": "Elk",
	"Subtype_Employee": "Employee",
	"Subtype_Eye": "Eye",
	"Subtype_Faerie": "Faerie",
	"Subtype_Ferret": "Ferret",
	"Subtype_Fish": "Fish",
	"Subtype_Flagbearer": "Flagbearer",
	"Subtype_Fox": "Fox",
	"Subtype_Fractal": "Fractal",
	"Subtype_Frog": "Frog",
	"Subtype_Fungus": "Fungus",
	"Subtype_Gamer": "Gamer",
	"Subtype_Gargoyle": "Gargoyle",
	"Subtype_Germ": "Germ",
	"Subtype_Giant": "Giant",
	"Subtype_Gith": "Gith",
	"Subtype_Gnoll": "Gnoll",
	"Subtype_Gnome": "Gnome",
	"Subtype_Goat": "Goat",
	"Subtype_Goblin": "Goblin",
	"Subtype_God": "God",
	"Subtype_Golem": "Golem",
	"Subtype_Gorgon": "Gorgon",
	"Subtype_Graveborn": "Graveborn",
	"Subtype_Gremlin": "Gremlin",
	"Subtype_Griffin": "Griffin",
	"Subtype_Guest": "Guest",
	"Subtype_Hag": "Hag",
	"Subtype_Halfling": "Halfling",
	"Subtype_Hamster": "Hamster",
	"Subtype_Harpy": "Harpy",
	"Subtype_Hellion": "Hellion",
	"Subtype_Hippo": "Hippo",
	"Subtype_Hippogriff": "Hippogriff",
	"Subtype_Homarid": "Homarid",
	"Subtype_Homunculus": "Homunculus",
	"Subtype_Horror": "Horror",
	"Subtype_Horse": "Horse",
	"Subtype_Human": "Human",
	"Subtype_Hydra": "Hydra",
	"Subtype_Hyena": "Hyena",
	"Subtype_Illusion": "Illusion",
	"Subtype_Imp": "Imp",
	"Subtype_Incarnation": "Incarnation",
	"Subtype_Inkling": "Inkling",
	"Subtype_Inquisitor": "Inquisitor",
	"Subtype_Insect": "Insect",
	"Subtype_Jackal": "Jackal",
	"Subtype_Jellyfish": "Jellyfish",
	"Subtype_Juggernaut": "Juggernaut",
	"Subtype_Kavu": "Kavu",
	"Subtype_Kirin": "Kirin",
	"Subtype_Kithkin": "Kithkin",
	"Subtype_Knight": "Knight",
	"Subtype_Kobold": "Kobold",
	"Subtype_Kor": "Kor",
	"Subtype_Kraken": "Kraken",
	"Subtype_Lamia": "Lamia",
	"Subtype_Lammasu": "Lammasu",
	"Subtype_Leech": "Leech",
	"Subtype_Leviathan": "Leviathan",
	"Subtype_Lhurgoyf": "Lhurgoyf",
	"Subtype_Licid": "Licid",
	"Subtype_Lizard": "Lizard",
	"Subtype_Manticore": "Manticore",
	"Subtype_Masticore": "Masticore",
	"Subtype_Mercenary": "Mercenary",
	"Subtype_Merfolk": "Merfolk",
	"Subtype_Metathran": "Metathran",
	"Subtype_Minion": "Minion",
	"Subtype_Minotaur": "Minotaur",
	"Subtype_Mite": "Mite",
	"Subtype_Mole": "Mole",
	"Subtype_Monger": "Monger",
	"Subtype_Mongoose": "Mongoose",
	"Subtype_Monk": "Monk",
	"Subtype_Monkey": "Monkey",
	"Subtype_Moonfolk": "Moonfolk",
	"Subtype_Mouse": "Mouse",
	"Subtype_Mutant": "Mutant",
	"Subtype_Myr": "Myr",
	"Subtype_Mystic": "Mystic",
	"Subtype_Naga": "Naga",
	"Subtype_Nautilus": "Nautilus",
	"Subtype_Necron": "Necron",
	"Subtype_Nephilim": "Nephilim",
	"Subtype_Nightmare": "Nightmare",
	"Subtype_Nightstalker": "Nightstalker",
	"Subtype_Ninja": "Ninja",
	"Subtype_Noble": "Noble",
	"Subtype_Noggle": "Noggle",
	"Subtype_Nomad": "Nomad",
	"Subtype_Nymph": "Nymph",
	"Subtype_Octopus": "Octopus",
	"Subtype_Ogre": "Ogre",
	"Subtype_Ooze": "Ooze",
	"Subtype_Orc": "Orc",
	"Subtype_Orgg": "Orgg",
	"Subtype_Otter": "Otter",
	"Subtype_Ouphe": "Ouphe",
	"Subtype_Ox": "Ox",
	"Subtype_Oyster": "Oyster",
	"Subtype_Pangolin": "Pangolin",
	"Subtype_Peasant": "Peasant",
	"Subtype_Pegasus": "Pegasus",
	"Subtype_Pentavite": "Pentavite",
	"Subtype_Performer": "Performer",
	"Subtype_Pest": "Pest",
	"Subtype_Phelddagrif": "Phelddagrif",
	"Subtype_Phoenix": "Phoenix",
	"Subtype_Phyrexian": "Phyrexian",
	"Subtype_Pilot": "Pilot",
	"Subtype_Pirate": "Pirate",
	"Subtype_Plant": "Plant",
	"Subtype_Praetor": "Praetor",
	"Subtype_Primarch": "Primarch",
	"Subtype_Processor": "Processor",
	"Subtype_Rabbit": "Rabbit",
	"Subtype_Raccoon": "Raccoon",
	"Subtype_Ranger": "Ranger",
	"Subtype_Rat": "Rat",
	"Subtype_Rebel": "Rebel",
	"Subtype_Reflection": "Reflection",
	"Subtype_Rhino": "Rhino",
	"Subtype_Rigger": "Rigger",
	"Subtype_Robot": "Robot",
	"Subtype_Rogue": "Rogue",
	"Subtype_Sable": "Sable",
	"Subtype_Salamander": "Salamander",
	"Subtype_Samurai": "Samurai",
	"Subtype_Sand": "Sand",
	"Subtype_Saproling": "Saproling",
	"Subtype_Satyr": "Satyr",
	"Subtype_Scarecrow": "Scarecrow",
	"Subtype_Scientist": "Scientist",
	"Subtype_Scion": "Scion",
	"Subtype_Scorpion": "Scorpion",
	"Subtype_Scout": "Scout",
	"Subtype_Sculpture": "Sculpture",
	"Subtype_Serf": "Serf",
	"Subtype_Serpent": "Serpent",
	"Subtype_Servo": "Servo",
	"Subtype_Shade": "Shade",
	"Subtype_Shaman": "Shaman",
	"Subtype_Shapeshifter": "Shapeshifter",
	"Subtype_Shark": "Shark",
	"Subtype_Sheep": "Sheep",
	"Subtype_Siren": "Siren",
	"Subtype_Skeleton": "Skeleton",
	"Subtype_Slith": "Slith",
	"Subtype_Sliver": "Sliver",
	"Subtype_Slug": "Slug",
	"Subtype_Snail": "Snail",
	"Subtype_Snake": "Snake",
	"Subtype_Soldier": "Soldier",
	"Subtype_Soltari": "Soltari",
	"Subtype_Spawn": "Spawn",
	"Subtype_Specter": "Specter",
	"Subtype_Spellshaper": "Spellshaper",
	"Subtype_Sphinx": "Sphinx",
	"Subtype_Spider": "Spider",
	"Subtype_Spike": "Spike",
	"Subtype_Spirit": "Spirit",
	"Subtype_Splinter": "Splinter",
	"Subtype_Sponge": "Sponge",
	"Subtype_Squid": "Squid",
	"Subtype_Squirrel": "Squirrel",
	"Subtype_Starfish": "Starfish",
	"Subtype_Surrakar": "Surrakar",
	"Subtype_Survivor": "Survivor",
	"Subtype_Tentacle": "Tentacle",
	"Subtype_Thalakos": "Thalakos",
	"Subtype_Thopter": "Thopter",
	"Subtype_Thrull": "Thrull",
	"Subtype_Tiefling": "Tiefling",
	"Subtype_Time Lord": "Time Lord",
	"Subtype_Treefolk": "Treefolk",
	"Subtype_Trilobite": "Trilobite",
	"Subtype_Triskelavite": "Triskelavite",
	"Subtype_Troll": "Troll",
	"Subtype_Turtle": "Turtle",
	"Subtype_Tyranid": "Tyranid",
	"Subtype_Unicorn": "Unicorn",
	"Subtype_Vampire": "Vampire",
	"Subtype_Vedalken": "Vedalken",
	"Subtype_Volver": "Volver",
	"Subtype_Wall": "Wall",
	"Subtype_Walrus": "Walrus",
	"Subtype_Warlock": "Warlock",
	"Subtype_Warrior": "Warrior",
	"Subtype_Weird": "Weird",
	"Subtype_Werewolf": "Werewolf",
	"Subtype_Whale": "Whale",
	"Subtype_Wizard": "Wizard",
	"Subtype_Wolf": "Wolf",
	"Subtype_Wolverine": "Wolverine",
	"Subtype_Wombat": "Wombat",
	"Subtype_Worm": "Worm",
	"Subtype_Wraith": "Wraith",
	"Subtype_Wurm": "Wurm",
	"Subtype_Yeti": "Yeti",
	"Subtype_Zombie": "Zombie",
	"Subtype_Zubera": "Zubera",
	"Subtype_Siege": "Siege",
	"FrameEffect_null": "null",
	"FrameEffect_colorshifted": "colorshifted",
	"FrameEffect_companion": "companion",
	"FrameEffect_compasslanddfc": "compasslanddfc",
	"FrameEffect_convertdfc": "convertdfc",
	"FrameEffect_devoid": "devoid",
	"FrameEffect_draft": "draft",
	"FrameEffect_enchantment": "enchantment",
	"FrameEffect_etched": "etched",
	"FrameEffect_extendedart": "extendedart",
	"FrameEffect_fandfc": "fandfc",
	"FrameEffect_fullart": "fullart",
	"FrameEffect_inverted": "inverted",
	"FrameEffect_legendary": "legendary",
	"FrameEffect_lesson": "lesson",
	"FrameEffect_miracle": "miracle",
	"FrameEffect_mooneldrazidfc": "mooneldrazidfc",
	"FrameEffect_originpwdfc": "originpwdfc",
	"FrameEffect_shatteredglass": "shatteredglass",
	"FrameEffect_showcase": "showcase",
	"FrameEffect_snow": "snow",
	"FrameEffect_spree": "spree",
	"FrameEffect_sunmoondfc": "sunmoondfc",
	"FrameEffect_tombstone": "tombstone",
	"FrameEffect_upsidedowndfc": "upsidedowndfc",
	"FrameEffect_waxingandwaningmoondfc": "waxingandwaningmoondfc"
}